module.exports = __webpack_public_path__ + "img/icon (6).b878b347.png";